/* eslint-disable max-len */
import {
  DRYER_INFO,
  COOKTOP_INFO,
  LAUNDRY_ACCESSORY_INFO
} from './info-drawers';

export const DEFAULT_GROUP = 'Product';
export const ANALYTICS_NOT_APPLICABLE = 'n/a';
export const DEFAULT_ACCESSORY_HEADING = 'Bundle Accessories';

export const DECLINE_MESSAGES = {
  Laundry: 'We offer installation for this laundry bundle, but will only install pedestals or stacking kits when purchased with your washer/dryer.',
  Kitchen: 'We offer installation for this kitchen bundle, but will only install accessories when purchased with your oven/cooktop.'
};

export const DELIVERY_MESSAGING = {
  CHARGE: '',
  FREE: 'Free Delivery',
  THRESHOLD: 'Free delivery on appliance purchases of $396 and up'
};

export const ACCESSORY_CATEGORIES = [
  'Pedestal',
  'Part/Accessory'
];

export const CATEGORY_LABEL_MAPPING = {
  Pedestal: 'Pedestal',
  'Part/Accessory': 'Stacking Kit'
};

export const ACCESSORY_HEADER_MAPPING = {
  Pedestal: 'Raised',
  'Part/Accessory': 'Stacked'
};

export const ACCESSORY_GROUPS = {
  LAUNDRY: 'Laundry',
  KITCHEN: 'Kitchen'
};

export const INFO_DRAWERS = {
  Washer: {},
  Dryer: DRYER_INFO,
  Combo: {},
  Oven: {},
  // ADD COOKTOP DRAWER LATER
  Cooktop: {},
  LAUNDRY_ACCESSORIES: LAUNDRY_ACCESSORY_INFO,
  KITCHEN_ACCESSORIES: {}
};

export const BUNDLE_TYPES = Object.freeze({
  LAUNDRY: Symbol('LAUNDRY'),
  KITCHEN: Symbol('KITCHEN'),
  DEFAULT: Symbol('DEFAULT')
});
